const church_time_items ={
    'church_time': {
        'type': 'time',
        'width': 'col-12',
        'class': '',
        'maxTime': true
    },
}
const grooms_time_items ={
    'grooms_time': {
        'type': 'time',

        'width': 'col-6',
        'class': '',
        'maxTime': true
    },
}
const parents_time_items ={
    'parents_time': {
        'type': 'time',

        'width': 'col-6',
        'class': '',
        'maxTime': true
    },
}
const preparation_time_pick_up_items ={
    'preparation_time_pick_up': {
        'type': 'time',
        'width': 'col-12',
        'class': '',
        'maxTime': true
    }
}
const preparation_time_items ={
    'preparation_time': {
        'type': 'time',
        'width': 'col-6',
        'class': '',
        'maxTime': true
    }
}
const menus_number_items ={
    'menus_number': {
        'type': 'number',
        'width': 'col-12',
        'class': ''
    },
    'drink_menus_number': {
        'type': 'number',
        'width': 'col-12',
        'class': ''
    },
}
const food_standard_items ={
    'food': {
        'label': true,
        'type': 'tab-switch',
        'width': 'col-12',
        'class': 'border-grey-top bg-dark',
        'values': {
            'false': 'swedish_buffet',
            'true': 'serving_at_the_table',
        },
    },
    'food_service': {
        'label': true,
        'type': 'tab-switch',
        'width': 'col-12',
        'class': ' bg-dark',
        'values': {
            'false': 'all_at_the_same_time',
            'true': 'at_different_times',
        },
        'conditions': [
            {
                'field': 'food',
                'condition': 'eq',
                'value': 'swedish_buffet'
            }
        ],
    },
    'service_time_all': {
        'type': 'time',
        'width': 'col-12',
        'class': 'bg-dark',
        'conditions': [
            {
                'field': 'food',
                'condition': 'eq',
                'value': 'swedish_buffet'
            },
            {
                'field': 'food_service',
                'condition': 'eq',
                'value': 'all_at_the_same_time'
            }
        ],
    },
    'service_time': {
        'type': 'time_menu',
        'class': 'bg-dark',
        'conditions': [
            {
                'field': 'food',
                'condition': 'eq',
                'value': 'swedish_buffet'
            },
            {
                'field': 'food_service',
                'condition': 'eq',
                'value': 'at_different_times'
            }
        ],
    },
    'service_time_table': {
        'type': 'time_menu',
        'class': 'bg-dark',
        'conditions': [
            {
                'field': 'food',
                'condition': 'eq',
                'value': 'serving_at_the_table'
            }
        ],
    },
}
const food_staff_items ={
    'food_staff_service': {
        'type': 'on-off',
        'width': 'col-12',
        'class': 'border-grey-top bg-light',
        'conditions': [
            {
                'field': 'food',
                'condition': 'neq',
                'value': 'swedish_buffet'
            }
        ]
    },
    'food_staff': {
        'label': true,
        'type': 'tab-switch',
        'width': 'col-12',
        'class': 'bg-light',
        'values': {
            'false': 'swedish_buffet',
            'true': 'serving_at_the_table',
        },
        'conditions': [
            {
                'field': 'food',
                'condition': 'neq',
                'value': 'swedish_buffet'
            },
            {
                'field': 'food_staff_service',
                'condition': 'eq',
                'value': false
            }
        ],
    },
    'food_service_staff': {
        'label': true,
        'type': 'tab-switch',
        'width': 'col-12',
        'class': 'bg-light',
        'values': {
            'false': 'all_at_the_same_time',
            'true': 'at_different_times',
        },
        'conditions': [
            {
                'field': 'food',
                'condition': 'neq',
                'value': 'swedish_buffet'
            },
            {
                'field': 'food_staff_service',
                'condition': 'eq',
                'value': false
            },
            {
                'field': 'food_staff',
                'condition': 'eq',
                'value': 'swedish_buffet'
            }
        ],
    },
    'service_time_all_staff': {
        'type': 'time',
        'width': 'col-12',
        'class': 'bg-light',
        'conditions': [
            {
                'field': 'food',
                'condition': 'neq',
                'value': 'swedish_buffet'
            },
            {
                'field': 'food_staff_service',
                'condition': 'eq',
                'value': false
            },
            {
                'field': 'food_staff',
                'condition': 'eq',
                'value': 'swedish_buffet'
            },
            {
                'field': 'food_service_staff',
                'condition': 'eq',
                'value': 'all_at_the_same_time'
            }
        ],
    },
    'service_time_staff': {
        'type': 'time_menu',
        'class': 'bg-light',
        'conditions': [
            {
                'field': 'food',
                'condition': 'neq',
                'value': 'swedish_buffet'
            },
            {
                'field': 'food_staff_service',
                'condition': 'eq',
                'value': false
            },
            {
                'field': 'food_staff',
                'condition': 'eq',
                'value': 'swedish_buffet'
            },
            {
                'field': 'food_service_staff',
                'condition': 'eq',
                'value': 'at_different_times'
            }
        ],
    },
    'service_time_table_staff': {
        'type': 'time_menu',
        'class': 'bg-light',
        'conditions': [
            {
                'field': 'food',
                'condition': 'neq',
                'value': 'swedish_buffet'
            },
            {
                'field': 'food_staff_service',
                'condition': 'eq',
                'value': false
            },
            {
                'field': 'food_staff',
                'condition': 'eq',
                'value': 'serving_at_the_table'
            }
        ],
    },
}
const food_children_items ={
    'food_children_service': {
        'type': 'on-off',
        'width': 'col-12',
        'class': 'border-grey-top bg-dark',
        'conditions': [
            {
                'field': 'food',
                'condition': 'neq',
                'value': 'swedish_buffet'
            }
        ]
    },
    'food_children': {
        'label': true,
        'type': 'tab-switch',
        'width': 'col-12',
        'class': 'bg-dark',
        'values': {
            'false': 'swedish_buffet',
            'true': 'serving_at_the_table',
        },
        'conditions': [
            {
                'field': 'food',
                'condition': 'neq',
                'value': 'swedish_buffet'
            },
            {
                'field': 'food_children_service',
                'condition': 'eq',
                'value': false
            }
        ],
    },
    'food_service_children': {
        'label': true,
        'type': 'tab-switch',
        'width': 'col-12',
        'class': 'bg-dark',
        'values': {
            'false': 'all_at_the_same_time',
            'true': 'at_different_times',
        },
        'conditions': [
            {
                'field': 'food',
                'condition': 'neq',
                'value': 'swedish_buffet'
            },
            {
                'field': 'food_children_service',
                'condition': 'eq',
                'value': false
            },
            {
                'field': 'food_children',
                'condition': 'eq',
                'value': 'swedish_buffet'
            }
        ],
    },
    'service_time_all_children': {
        'type': 'time',
        'width': 'col-12',
        'class': 'bg-dark',
        'conditions': [
            {
                'field': 'food',
                'condition': 'neq',
                'value': 'swedish_buffet'
            },
            {
                'field': 'food_children_service',
                'condition': 'eq',
                'value': false
            },
            {
                'field': 'food_children',
                'condition': 'eq',
                'value': 'swedish_buffet'
            },
            {
                'field': 'food_service_children',
                'condition': 'eq',
                'value': 'all_at_the_same_time'
            }
        ],
    },
    'service_time_children': {
        'type': 'time_menu',
        'class': 'bg-dark',
        'conditions': [
            {
                'field': 'food',
                'condition': 'neq',
                'value': 'swedish_buffet'
            },
            {
                'field': 'food_children_service',
                'condition': 'eq',
                'value': false
            },
            {
                'field': 'food_children',
                'condition': 'eq',
                'value': 'swedish_buffet'
            },
            {
                'field': 'food_service_children',
                'condition': 'eq',
                'value': 'at_different_times'
            }
        ],
    },
    'service_time_table_children': {
        'type': 'time_menu',
        'class': 'bg-dark',
        'conditions': [
            {
                'field': 'food',
                'condition': 'neq',
                'value': 'swedish_buffet'
            },
            {
                'field': 'food_children_service',
                'condition': 'eq',
                'value': false
            },
            {
                'field': 'food_children',
                'condition': 'eq',
                'value': 'serving_at_the_table'
            }
        ],
    },
}
const cake_items = {
    'cake': {
        'label': true,
        'type': 'tab-switch',
        'width': 'col-12',
        'class': 'border-grey-top',
        'values': {
            'false': 'salon',
            'true': 'client',
        },
    },
    'cake_provider_name': {
        'conditions': [
            {
                'field': 'cake',
                'condition': 'eq',
                'value': 'client'
            }
        ],
        'type': 'text',
        'width': 'col-12',
        'class': 'd-flex'
    },
    'cake_provider_phone': {
        'conditions': [
            {
                'field': 'cake',
                'condition': 'eq',
                'value': 'client'
            }
        ],
        'type': 'text',

        'width': 'col-6',
        'class': ''
    },
    'cake_provider_time': {
        'conditions': [
            {
                'field': 'cake',
                'condition': 'eq',
                'value': 'client'
            }
        ],
        'type': 'time',

        'width': 'col-6',
        'class': '',
        'maxTime': true
    },
    'service_time_cake': {
        'type': 'time',
        'width': 'col-12',
        'class': '',
    },
}
const add_taxes_items = {
    'add_taxes': {
        'type': 'button',
        'width': 'col-12',
        'class': '',
        'content': 'taxes'
    }}

const set_up_number_guests_tables_items ={
    'number_guests_tables': {
        'type': 'number',
        'width': 'col-6',
        'class': ''
    },
  /*  'empty_number_guests_tables': {
        'conditions': [
            {
                'field': 'number_guests_tables',
                'condition': 'eq',
                'value': 0
            }
        ],
        'type': 'null',
        'width': 'col-6',
        'class': ''
    },*/
    'guests_tables_type': {
      /*  'conditions': [
            {
                'field': 'number_guests_tables',
                'condition': 'neq',
                'value': 0
            }
        ],*/
        'type': 'tab-switch',
        'width': 'col-6',
        'class': '',
        'values': {
            'false': 'round',
            'true': 'rectangular',
        },
    }
}
const set_up_chairs_items ={
    'chairs': {
        'label': true,
        'type': 'tab-switch',
        'width': 'col-6',
       // 'class': 'border-grey-top',
        'values': {
            'false': 'salon',
            'true': 'client',
        },
    },
    'number_chairs': {
        'conditions': [
            {
                'field': 'chairs',
                'condition': 'eq',
                'value': 'salon'
            }
        ],
        'type': 'number',
        'width': 'col-6',
       /* 'class': 'border-grey-top'*/
    },
    'chairs_provider_name': {
        'conditions': [
            {
                'field': 'chairs',
                'condition': 'eq',
                'value': 'client'
            }
        ],
        'type': 'text',
        'width': 'col-6',
        'class': 'border-grey-top'
    },
    'chairs_provider_phone': {
        'conditions': [
            {
                'field': 'chairs',
                'condition': 'eq',
                'value': 'client'
            }
        ],
        'type': 'text',
        'width': 'col-6',
        'class': ''
    },
    'chairs_provider_time': {
        'conditions': [
            {
                'field': 'chairs',
                'condition': 'eq',
                'value': 'client'
            }
        ],
        'type': 'time',
        'width': 'col-6',
        'class': '',
        'maxTime': true
    }
}
const set_up_number_staff_tables_items ={
    'number_staff_tables': {
        'type': 'number',
        'width': 'col-6',
        'class': 'border-grey-top'
    },
    'staff_tables_type': {
      /*  'conditions': [
            {
                'field': 'number_staff_tables',
                'condition': 'neq',
                'value': 0
            }
        ],*/
        'type': 'tab-switch',
        'width': 'col-6',
        'class': 'border-grey-top',
        'values': {
            'false': 'round',
            'true': 'rectangular',
        },
    }
}
const set_up_presidium_items ={
    'presidium_number_of_peaple': {
        'conditions': [
            {
                'field': 'presidium',
                'condition': 'eq',
                'value': true
            }
        ],
        'type': 'number',
        'width': 'col-6',
        'class': 'border-grey-top'
    },
    'presidium_type': {
        'conditions': [
            {
                'field': 'presidium',
                'condition': 'eq',
                'value': true
            }
        ],
        'type': 'tab-switch',
        'width': 'col-6',
        'class': 'border-grey-top',
        'values': {
            'false': 'round',
            'true': 'rectangular',
        },
    }
}
const set_up_candy_bar_tables_items ={
    'candy_bar_tables': {
        'conditions': [
            {
                'field': 'candy_bar',
                'condition': 'eq',
                'value': true
            }
        ],
        'label': true,
        'type': 'tab-switch',
        'width': 'col-12',
        'class': 'border-grey-top',
        'values': {
            'false': 'salon',
            'true': 'client',
        },
    },
    'candy_bar_tables_number': {
        'conditions': [
            {
                'field': 'candy_bar',
                'condition': 'eq',
                'value': true
            },
            {
                'field': 'candy_bar_tables',
                'condition': 'eq',
                'value': 'salon'
            }
        ],
        'type': 'number',
        'width': 'col-12',
        'class': ''
    },
    'candy_bar_provider_name': {
        'conditions': [
            {
                'field': 'candy_bar_tables',
                'condition': 'eq',
                'value': 'client'
            }
        ],
        'type': 'text',
        'width': 'col-12',
        'class': ''
    },
    'candy_bar_provider_phone': {
        'conditions': [
            {
                'field': 'candy_bar_tables',
                'condition': 'eq',
                'value': 'client'
            }
        ],
        'type': 'text',
        'width': 'col-6',
        'class': ''
    },
    'candy_bar_provider_time': {
        'conditions': [
            {
                'field': 'candy_bar_tables',
                'condition': 'eq',
                'value': 'client'
            }
        ],
        'type': 'time',
        'width': 'col-6',
        'class': '',
        'maxTime': true
    }
}
const set_up_cheese_bar_tables_items ={
    'cheese_bar_tables': {
        'conditions': [
            {
                'field': 'cheese_bar',
                'condition': 'eq',
                'value': true
            }
        ],
        'label': true,
        'type': 'tab-switch',
        'width': 'col-12',
        'class': 'border-grey-top',
        'values': {
            'false': 'salon',
            'true': 'client',
        },
    },
    'cheese_bar_tables_number': {
        'conditions': [
            {
                'field': 'cheese_bar',
                'condition': 'eq',
                'value': true
            },
            {
                'field': 'cheese_bar_tables',
                'condition': 'eq',
                'value': 'salon'
            }
        ],
        'type': 'number',
        'width': 'col-12',
        'class': ''
    },
    'cheese_bar_provider_name': {
        'conditions': [
            {
                'field': 'cheese_bar_tables',
                'condition': 'eq',
                'value': 'client'
            }
        ],
        'type': 'text',
        'width': 'col-12',
        'class': ''
    },
    'cheese_bar_provider_phone': {
        'conditions': [
            {
                'field': 'cheese_bar_tables',
                'condition': 'eq',
                'value': 'client'
            }
        ],
        'type': 'text',
        'width': 'col-6',
        'class': ''
    },
    'cheese_bar_provider_time': {
        'conditions': [
            {
                'field': 'cheese_bar_tables',
                'condition': 'eq',
                'value': 'client'
            }
        ],
        'type': 'time',
        'width': 'col-6',
        'class': '',
        'maxTime': true
    }
}
const set_up_gelato_bar_tables_items ={
    'gelato_bar_tables': {
        'conditions': [
            {
                'field': 'gelato_bar',
                'condition': 'eq',
                'value': true
            }
        ],
        'label': true,
        'type': 'tab-switch',
        'width': 'col-12',
        'class': 'border-grey-top',
        'values': {
            'false': 'salon',
            'true': 'client',
        },
    },
    'gelato_bar_tables_number': {
        'conditions': [
            {
                'field': 'gelato_bar',
                'condition': 'eq',
                'value': true
            },
            {
                'field': 'gelato_bar_tables',
                'condition': 'eq',
                'value': 'salon'
            }
        ],
        'type': 'number',
        'width': 'col-12',
        'class': ''
    },
    'gelato_bar_provider_name': {
        'conditions': [
            {
                'field': 'gelato_bar_tables',
                'condition': 'eq',
                'value': 'client'
            }
        ],
        'type': 'text',
        'width': 'col-12',
        'class': ''
    },
    'gelato_bar_provider_phone': {
        'conditions': [
            {
                'field': 'gelato_bar_tables',
                'condition': 'eq',
                'value': 'client'
            }
        ],
        'type': 'text',

        'width': 'col-6',
        'class': ''
    },
    'gelato_bar_provider_time': {
        'conditions': [
            {
                'field': 'gelato_bar_tables',
                'condition': 'eq',
                'value': 'client'
            }
        ],
        'type': 'time',

        'width': 'col-6',
        'class': '',
        'maxTime': true
    }
}
const set_up_lemonade_bar_tables_items ={
    'lemonade_bar_tables': {
        'conditions': [
            {
                'field': 'lemonade_bar',
                'condition': 'eq',
                'value': true
            }
        ],
        'label': true,
        'type': 'tab-switch',
        'width': 'col-12',
        'class': 'border-grey-top',
        'values': {
            'false': 'salon',
            'true': 'client',
        },
    },
    'lemonade_bar_tables_number': {
        'conditions': [
            {
                'field': 'lemonade_bar',
                'condition': 'eq',
                'value': true
            },
            {
                'field': 'lemonade_bar_tables',
                'condition': 'eq',
                'value': 'salon'
            }
        ],
        'type': 'number',
        'width': 'col-12',
        'class': ''
    },
    'lemonade_bar_provider_name': {
        'conditions': [
            {
                'field': 'lemonade_bar_tables',
                'condition': 'eq',
                'value': 'client'
            }
        ],
        'type': 'text',
        'width': 'col-12',
        'class': ''
    },
    'lemonade_bar_provider_phone': {
        'conditions': [
            {
                'field': 'lemonade_bar_tables',
                'condition': 'eq',
                'value': 'client'
            }
        ],
        'type': 'text',

        'width': 'col-6',
        'class': ''
    },
    'lemonade_bar_provider_time': {
        'conditions': [
            {
                'field': 'lemonade_bar_tables',
                'condition': 'eq',
                'value': 'client'
            }
        ],
        'type': 'time',

        'width': 'col-6',
        'class': '',
        'maxTime': true
    }
}
const set_up_cocktail_tereace_cocktail_number_items ={
    'cocktail_tereace_cocktail_number': {
        'conditions': [
            {
                'field': 'tereace_cocktail_tables',
                'condition': 'eq',
                'value': true
            }
        ],
        'type': 'number',
        'width': 'col-12',
        'class': 'border-grey-top'
    }
}
const set_up_cocktail_salon_cocktail_number_items ={
    'cocktail_salon_cocktail_number': {
        'conditions': [
            {
                'field': 'salon_cocktail_tables',
                'condition': 'eq',
                'value': true
            }
        ],
        'type': 'number',
        'width': 'col-12',
        'class': ''
    }
}
const set_up_another_services_info_items ={
    'another_services_info': {
        'conditions': [
            {
                'field': 'another_services',
                'condition': 'eq',
                'value': true
            }
        ],
        'type': 'text',
        'width': 'col-12',
        'class': 'border-grey-top'
    }
}
const set_up_hall_plan_items ={
    'hall_plan': {
        'type': 'upload',
        'width': 'col-12',
        'class': '',
        'accept': '.doc,.docx,.pdf'
    },
}

const standard_bars_items = {
    'candy_bar': {
        'type': 'checkbox',
        'width': 'col-12',
        'class': '',
    },
    'cheese_bar': {
        'type': 'checkbox',
        'width': 'col-12',
        'class': '',
    },
    'gelato_bar': {
        'type': 'checkbox',
        'width': 'col-12',
        'class': '',
    },
    'lemonade_bar': {
        'type': 'checkbox',
        'width': 'col-12',
        'class': '',
    },
}
const set_up_add_button_sheet_1_2_items ={
    'add': {
        'type': 'button',
        'width': 'col-12',
        'class': '',
        'content': standard_bars_items
    },
}
const set_up_add_button_sheet_3_4_5_items ={
    'add': {
        'type': 'button',
        'width': 'col-12',
        'class': '',
        'content': {
            'presidium': {
                'type': 'checkbox',
                'width': 'col-12',
                'class': '',
            },
            ...standard_bars_items,
            'tereace_cocktail_tables': {
                'type': 'checkbox',
                'width': 'col-6',
                'class': '',
            },
            'salon_cocktail_tables': {
                'type': 'checkbox',
                'width': 'col-6',
                'class': '',
            },
            'another_services': {
                'type': 'checkbox',
                'width': 'col-6',
                'class': '',
            },
        }
    },
}
const set_up_textboxes_items ={
    'textboxes': {
        'type': 'array_of_textboxes',
        'width': 'col-12',
        'class': '',
        'content': {
            'title': {
                'type': 'text',
                'width': 'col-12',
                'class': '',
            },
        }
    }
}
const sheet1 = {
    'general': {
        ...preparation_time_pick_up_items,
        ...menus_number_items,
        ...food_standard_items,
        ...food_staff_items,
        ...food_children_items,
        ...add_taxes_items
    },
    'set_up': {
        'set_up_type': {
            'type': 'select_from_list',
            'width': 'col-12',
            'class': '',
            'options': [
                {
                    'label': 'events.set_up.set_up_type.ballroom_cabaret',
                    'translate': true,
                    'value': 'ballroom_cabaret',
                },
                {
                    'label': 'events.set_up.set_up_type.theater',
                    'translate': true,
                    'value': 'theater',
                }
            ]
        },
        'number_tables': {
            'type': 'number',
            'width': 'col-12',
            'class': '',
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                }
            ],
        },
      /*  'empty_number_tables': {
            'conditions': [
                {
                    'field': 'number_tables',
                    'condition': 'eq',
                    'value': 0
                },
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                }
            ],
            'type': 'null',
            'width': 'col-6',
            'class': ''
        },*/
        'tables_type': {
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                },
                {
                    'field': 'number_tables',
                    'condition': 'neq',
                    'value': 0
                }
            ],
            'type': 'tab-switch',
            'width': 'col-6',
            'class': '',
            'values': {
                'false': 'round',
                'true': 'rectangular',
            },
        },
        ...set_up_chairs_items,
        'cocktail_tereace_cocktail_number': {
            'type': 'number',
            'width': 'col-12',
            'class': 'border-grey-top'
        },
        'cocktail_salon_cocktail_number': {
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'tablecloths': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': '',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                }
            ],
        },
        'tablecloths_provider_name': {
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                },
                {
                    'field': 'tablecloths',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': 'd-flex'
        },
        'tablecloths_provider_phone': {
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                },
                {
                    'field': 'tablecloths',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': ''
        },
        'tablecloths_provider_time': {
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                },
                {
                    'field': 'tablecloths',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'table_numbers': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                }
            ],
        },
        'table_numbers_provider_name': {
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                },
                {
                    'field': 'table_numbers',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'table_numbers_provider_phone': {
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                },
                {
                    'field': 'table_numbers',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': ''
        },
        'table_numbers_provider_time': {
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                },
                {
                    'field': 'table_numbers',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'table_arrangement': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                }
            ],
        },
        'table_arrangement_provider_name': {
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                },
                {
                    'field': 'table_arrangement',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'table_arrangement_provider_phone': {
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                },
                {
                    'field': 'table_arrangement',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': ''
        },
        'table_arrangement_provider_time': {
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                },
                {
                    'field': 'table_arrangement',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        ...set_up_candy_bar_tables_items,
        ...set_up_cheese_bar_tables_items,
        ...set_up_gelato_bar_tables_items,
        ...set_up_lemonade_bar_tables_items,
        ...set_up_hall_plan_items,
        ...set_up_add_button_sheet_1_2_items,
        ...set_up_textboxes_items
    },
}
const sheet2 = {
    'general': {
        ...preparation_time_pick_up_items,
        ...menus_number_items,
        ...food_standard_items,
        ...food_staff_items,
        ...food_children_items,
        ...cake_items,
        ...add_taxes_items
    },
    'set_up': {
        'set_up_type': {
            'type': 'select_from_list',
            'width': 'col-12',
            'class': '',
            'options': [
                {
                    'label': 'events.set_up.set_up_type.ballroom',
                    'translate': true,
                    'value': 'ballroom',
                },
                {
                    'label': 'events.set_up.set_up_type.club',
                    'translate': true,
                    'value': 'club',
                },
                {
                    'label': 'events.set_up.set_up_type.mixt',
                    'translate': true,
                    'value': 'mixt',
                }
            ]
        },
        'number_couches': {
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'club',
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'number_tables': {
            'type': 'number',
            'width': 'col-12',
            'class': '',
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                }
            ],
        },
      /*  'empty_number_tables': {
            'conditions': [
                {
                    'field': 'number_tables',
                    'condition': 'eq',
                    'value': 0
                },
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                }
            ],
            'type': 'null',
            'width': 'col-6',
            'class': ''
        },*/
        'tables_type': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'number_tables',
                    'condition': 'neq',
                    'value': 0
                }
            ],
            'type': 'tab-switch',
            'width': 'col-6',
            'class': '',
            'values': {
                'false': 'round',
                'true': 'rectangular',
            },
        },
        'chairs': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-6',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                }
            ],
        },
        'number_chairs': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-6',
            'class': 'border-grey-top'
        },
        'chairs_provider_name': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': 'border-grey-top'
        },
        'chairs_provider_phone': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': ''
        },
        'chairs_provider_time': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'cocktail_tereace_cocktail_number': {
            'type': 'number',
            'width': 'col-12',
            'class': 'border-grey-top'
        },
        'cocktail_salon_cocktail_number': {
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'tablecloths': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-6',
            'class': '',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                }
            ],
        },
        'tablecloths_provider_name': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'tablecloths',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': 'd-flex'
        },
        'tablecloths_provider_phone': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'tablecloths',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': ''
        },
        'tablecloths_provider_time': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'tablecloths',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'table_numbers': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-6',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                }
            ],
        },
        'table_numbers_provider_name': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'table_numbers',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': 'border-grey-top'
        },
        'table_numbers_provider_phone': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'table_numbers',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': ''
        },
        'table_numbers_provider_time': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'table_numbers',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'table_arrangement': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                }
            ],
        },
        'table_arrangement_provider_name': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'table_arrangement',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'table_arrangement_provider_phone': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'table_arrangement',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': ''
        },
        'table_arrangement_provider_time': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'table_arrangement',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        ...set_up_candy_bar_tables_items,
        ...set_up_cheese_bar_tables_items,
        ...set_up_gelato_bar_tables_items,
        ...set_up_lemonade_bar_tables_items,
        ...set_up_hall_plan_items,
        ...set_up_add_button_sheet_1_2_items,
        ...set_up_textboxes_items
    },
}
const sheet3 = {
    'general': {
        ...preparation_time_items,
        ...parents_time_items,
        ...menus_number_items,
        ...food_standard_items,
        ...food_staff_items,
        ...food_children_items,
        ...cake_items,
        ...add_taxes_items
    },
    'set_up': {
        ...set_up_number_guests_tables_items,
        ...set_up_chairs_items,
        ...set_up_number_staff_tables_items,
        ...set_up_presidium_items,
        ...set_up_candy_bar_tables_items,
        ...set_up_cheese_bar_tables_items,
        ...set_up_gelato_bar_tables_items,
        ...set_up_lemonade_bar_tables_items,
        ...set_up_cocktail_tereace_cocktail_number_items,
        ...set_up_cocktail_salon_cocktail_number_items,
        ...set_up_another_services_info_items,
        ...set_up_hall_plan_items,
        ...set_up_add_button_sheet_3_4_5_items,
        ...set_up_textboxes_items
    },
}
const sheet4 = {
    'general': {
        ...preparation_time_items,
        ...parents_time_items,
        ...church_time_items,
        ...menus_number_items,
        ...food_standard_items,
        ...food_staff_items,
        ...food_children_items,
        ...cake_items,
        ...add_taxes_items
    },
    'set_up': {
        ...set_up_number_guests_tables_items,
        ...set_up_chairs_items,
        ...set_up_number_staff_tables_items,
        ...set_up_presidium_items,
        ...set_up_candy_bar_tables_items,
        ...set_up_cheese_bar_tables_items,
        ...set_up_gelato_bar_tables_items,
        ...set_up_lemonade_bar_tables_items,
        ...set_up_cocktail_tereace_cocktail_number_items,
        ...set_up_cocktail_salon_cocktail_number_items,
        ...set_up_another_services_info_items,
        ...set_up_hall_plan_items,
        ...set_up_add_button_sheet_3_4_5_items,
        ...set_up_textboxes_items
    },
}
const sheet5 = {
    'general': {
        ...preparation_time_items,
        ...grooms_time_items,
        ...church_time_items,
        ...menus_number_items,
        ...food_standard_items,
        ...food_staff_items,
        ...food_children_items,
        ...cake_items,
        ...add_taxes_items

    },
    'set_up': {
        ...set_up_number_guests_tables_items,
        ...set_up_chairs_items,
        ...set_up_number_staff_tables_items,
        ...set_up_presidium_items,
        ...set_up_candy_bar_tables_items,
        ...set_up_cheese_bar_tables_items,
        ...set_up_gelato_bar_tables_items,
        ...set_up_lemonade_bar_tables_items,
        ...set_up_cocktail_tereace_cocktail_number_items,
        ...set_up_cocktail_salon_cocktail_number_items,
        ...set_up_another_services_info_items,
        ...set_up_hall_plan_items,
        ...set_up_add_button_sheet_3_4_5_items,
        ...set_up_textboxes_items
    },
}
const sheet6 = {
    'general': {
        'improvement': {
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'final_hour': {
            'type': 'time',
            'width': 'col-6',
            'class': ''
        },
        'moving': {
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'minTime': true
        },
        'number_of_participants': {
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'psi': {
            'type': 'input_with_options',
            'width': 'col-12',
            'class': '',
            'isMulti': true,
            'options': [
                {
                    'label': 'events.sheet.general.psi.security',
                },
                {
                    'label': 'events.sheet.general.psi.first_aid',
                },
                {
                    'label': 'events.sheet.general.psi.firefighters',
                }
            ]
        },
        'timetable': {
            'type': 'upload',
            'width': 'col-12',
            'class': 'border-grey-top',
            'accept': '.pdf'
        },
        'day_laborer': {
            'type': 'on-off',
            'width': 'col-12',
            'class': 'border-grey-top',
        },
        'day_laborer_responsible': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
            'conditions': [
                {
                    'field': 'day_laborer',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'isu': {
            'type': 'on-off',
            'width': 'col-12',
            'class': 'border-grey-top',
        },
        'isu_responsible': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
            'conditions': [
                {
                    'field': 'isu',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'ucmr_ada': {
            'type': 'on-off',
            'width': 'col-12',
            'class': 'border-grey-top',
        },
        'ucmr_ada_responsible': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
            'conditions': [
                {
                    'field': 'ucmr_ada',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'other_details': {
            'type': 'text',
            'width': 'col-12',
            'class': 'border-grey-top'
        },
        ...add_taxes_items
    },
    'bar': {
        'sale_bar': {
            'type': 'on-off',
            'width': 'col-12',
            'class': '',
        },
        'responsible': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'managers': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
            'isMulti': true,
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'managers_fee': {
            'type': 'fee',
            'width': 'col-12',
            'class': '',
            'for': 'managers',
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'bartender': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
            'isMulti': true,
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'bartender_fee': {
            'type': 'fee',
            'width': 'col-12',
            'class': '',
            'for': 'bartender',
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'help_bar': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
            'isMulti': true,
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'help_bar_fee': {
            'type': 'fee',
            'width': 'col-12',
            'class': '',
            'for': 'help_bar',
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'sale_mode': {
            'type': 'tab-switch',
            'width': 'col-12',
            'class': '',
            'label': 'sale_mode',
            'values': {
                'false': 'open_bar',
                'true': 'sale',
            },
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'sale': {
            'type': 'tab-switch',
            'width': 'col-12',
            'class': '',
            'values': {
                'false': 'salon',
                'true': 'provider',
            },
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'sale_mode',
                    'condition': 'eq',
                    'value': 'sale'
                }
            ],
        },
        'sale_provider': {
            'type': 'select_provider',
            'width': 'col-6',
            'class': '',
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'sale_mode',
                    'condition': 'eq',
                    'value': 'sale'
                },
                {
                    'field': 'sale',
                    'condition': 'eq',
                    'value': 'provider'
                },
            ],
        },
        'sale_responsible': {
            'type': 'select_staff',
            'width': 'col-6',
            'class': '',
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'sale_mode',
                    'condition': 'eq',
                    'value': 'sale'
                },
                {
                    'field': 'sale',
                    'condition': 'eq',
                    'value': 'provider'
                },
            ],
        },
        'supplies_responsible': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': 'border-grey-top',
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'drinks': {
            'type': 'select_from_list',
            'width': 'col-12',
            'class': '',
            'options': [
                {
                    'label': 'events.sheet.bar.drinks.location',
                    'translate': true,
                    'value': 'location',
                },
                {
                    'label': 'events.sheet.bar.drinks.salon',
                    'translate': true,
                    'value': 'salon',
                },
                {
                    'label': 'events.sheet.bar.drinks.provider',
                    'translate': true,
                    'value': 'provider',
                }
            ],
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_drinks',
                    'condition': 'eq',
                    'value': true
                },
            ],
        },
        'drinks_provider': {
            'type': 'select_provider',
            'width': 'col-12',
            'class': '',
            'minTime': true,
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_drinks',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'drinks',
                    'condition': 'eq',
                    'value': 'provider'
                },
            ],
        },
        'drinks_return': {
            'type': 'on-off',
            'width': 'col-12',
            'class': '',
            'maxTime': true,
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_drinks',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'drinks',
                    'condition': 'eq',
                    'value': 'provider'
                },
            ],
        },
        'drinks_delivery_time': {
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'maxTime': true,
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_drinks',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'drinks',
                    'condition': 'neq',
                    'value': 'location'
                },
            ],
        },
        'drinks_return_time': {
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'minTime': true,
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_drinks',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'drinks',
                    'condition': 'eq',
                    'value': 'salon'
                },
            ],
        },
        'drinks_return_time_2': {
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'minTime': true,
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_drinks',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'drinks',
                    'condition': 'eq',
                    'value': 'provider'
                },
                {
                    'field': 'drinks_return',
                    'condition': 'eq',
                    'value': true
                },
            ],
        },
        'drinks_provider_name': {
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_drinks',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'drinks',
                    'condition': 'eq',
                    'value': 'provider'
                },
                {
                    'field': 'drinks_return',
                    'condition': 'eq',
                    'value': true
                },
            ],
            'type': 'text',
            'width': 'col-6',
            'class': 'd-flex'
        },
        'drinks_provider_phone': {
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_drinks',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'drinks',
                    'condition': 'eq',
                    'value': 'provider'
                },
                {
                    'field': 'drinks_return',
                    'condition': 'eq',
                    'value': true
                },
            ],
            'type': 'text',
            'width': 'col-6',
            'class': ''
        },
        'glasses': {
            'type': 'select_from_list',
            'width': 'col-12',
            'class': '',
            'options': [
                {
                    'label': 'events.sheet.bar.drinks.location',
                    'translate': true,
                    'value': 'location',
                },
                {
                    'label': 'events.sheet.bar.drinks.salon',
                    'translate': true,
                    'value': 'salon',
                },
                {
                    'label': 'events.sheet.bar.drinks.provider',
                    'translate': true,
                    'value': 'provider',
                }
            ],
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_glasses',
                    'condition': 'eq',
                    'value': true
                },
            ],
        },
        'glasses_provider': {
            'type': 'select_provider',
            'width': 'col-12',
            'class': '',
            'minTime': true,
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_glasses',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'glasses',
                    'condition': 'eq',
                    'value': 'provider'
                },
            ],
        },
        'glasses_type': {
            'type': 'select_from_list',
            'width': 'col-12',
            'class': '',
            'options': [{
                'label': 'events.sheet.bar.glasses.glass',
                'translate': true,
                'value': 'glass',
            }, {
                'label': 'events.sheet.bar.glasses.cartoon',
                'translate': true,
                'value': 'cartoon',
            }],
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_glasses',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'glasses',
                    'condition': 'neq',
                    'value': 'location'
                },
            ],
        },
        'protocol': {
            'type': 'text',
            'width': 'col-12',
            'class': '',
            'values': {
                'false': 'salon',
                'true': 'provider',
            },
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_protocol',
                    'condition': 'eq',
                    'value': true
                },
            ],
        },
        'other': {
            'type': 'text',
            'width': 'col-12',
            'class': '',
            'values': {
                'false': 'salon',
                'true': 'provider',
            },
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_other',
                    'condition': 'eq',
                    'value': true
                },
            ],
        },
        'configure_supplies': {
            'type': 'button',
            'width': 'col-12',
            'class': '',
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'content': {
                'configure_drinks': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'configure_menus_print': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'configure_glasses': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'configure_fruits': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'configure_straws': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'configure_napkins': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'configure_bar_organizers': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'configure_ice_buckets': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'configure_soffits': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'configure_garbage_bags': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'configure_trash_cans': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'configure_ice': {
                    'type': 'checkbox',
                    'width': 'col-6',
                    'class': '',
                },
                'configure_protocol': {
                    'type': 'checkbox',
                    'width': 'col-6',
                    'class': '',
                },
                'configure_other': {
                    'type': 'checkbox',
                    'width': 'col-6',
                    'class': '',
                },
            }
        },
    },
    'set_up': {
        'truss': {
            'type': 'select_from_list',
            'width': 'col-12',
            'class': '',
            'options': [
                {
                    'label': 'events.sheet.bar.drinks.location',
                    'translate': true,
                    'value': 'location',
                },
                {
                    'label': 'events.sheet.bar.drinks.salon',
                    'translate': true,
                    'value': 'salon',
                },
                {
                    'label': 'events.sheet.bar.drinks.provider',
                    'translate': true,
                    'value': 'provider',
                }
            ],
        },
        'truss_responsible': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
        },
        'truss_provider': {
            'type': 'select_provider',
            'width': 'col-12',
            'class': '',
            'isMulti': true,
            'conditions': [
                {
                    'field': 'truss',
                    'condition': 'eq',
                    'value': 'provider'
                },
            ],
        },
        'backstage_responsible': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': 'border-grey-top',
            'isMulti': true
        },
        'backstage_details': {
            'type': 'text',
            'width': 'col-12',
            'class': '',
        },
        'btl_logistics': {
            'type': 'select_staff',
            'width': 'col-6',
            'class': 'border-grey-top',
        },
        'btl_logistics_fee': {
            'type': 'fee',
            'width': 'col-6',
            'class': 'border-grey-top',
            'for': 'btl_logistics',
        },
        'products': {
            'type': 'product_btl',
            'width': 'col-12',
            'class': '',
            'options': [
                {
                    'label': 'events.sheet.bar.drinks.location',
                    'translate': true,
                    'value': 'location',
                },
                {
                    'label': 'events.sheet.bar.drinks.salon',
                    'translate': true,
                    'value': 'salon',
                },
                {
                    'label': 'events.sheet.bar.drinks.provider',
                    'translate': true,
                    'value': 'provider',
                }
            ],
        },
        ...set_up_textboxes_items
    },
    'access': {
        'tichets': {
            'type': 'on-off',
            'width': 'col-12',
            'class': ''
        },
        'tichets_from': {
            'type': 'tab-switch',
            'width': 'col-12',
            'class': '',
            'values': {
                'false': 'salon',
                'true': 'provider',
            },
            'conditions': [
                {
                    'field': 'tichets',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'tichets_provider': {
            'type': 'select_provider',
            'width': 'col-12',
            'class': '',
            'conditions': [
                {
                    'field': 'tichets',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'tichets_from',
                    'condition': 'eq',
                    'value': 'provider'
                }
            ],
        },
        'tichets_responsible': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
            'conditions': [
                {
                    'field': 'tichets',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'tichets_from',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
        },
        'bracelets': {
            'type': 'on-off',
            'width': 'col-12',
            'class': ''
        },
        'bracelets_from': {
            'type': 'tab-switch',
            'width': 'col-12',
            'class': '',
            'values': {
                'false': 'salon',
                'true': 'provider',
            },
            'conditions': [
                {
                    'field': 'bracelets',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'bracelets_provider': {
            'type': 'select_provider',
            'width': 'col-12',
            'class': '',
            'conditions': [
                {
                    'field': 'bracelets',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'bracelets_from',
                    'condition': 'eq',
                    'value': 'provider'
                }
            ],
        },
        'bracelets_responsible': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
            'conditions': [
                {
                    'field': 'bracelets',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'bracelets_from',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
        },
        'guestlist': {
            'type': 'on-off',
            'width': 'col-12',
            'class': ''
        },
        'guestlist_from': {
            'type': 'tab-switch',
            'width': 'col-12',
            'class': '',
            'values': {
                'false': 'salon',
                'true': 'provider',
            },
            'conditions': [
                {
                    'field': 'guestlist',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'guestlist_provider': {
            'type': 'select_provider',
            'width': 'col-12',
            'class': '',
            'conditions': [
                {
                    'field': 'guestlist',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'guestlist_from',
                    'condition': 'eq',
                    'value': 'provider'
                }
            ],
        },
        'guestlist_responsible': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
            'conditions': [
                {
                    'field': 'guestlist',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'guestlist_from',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
        },
        'other': {
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },

    },
    'activations': {
        'responsible': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
        },
        'activations_list': {
            'type': 'select_activation',
            'width': 'col-12',
            'class': 'border-grey-top ',
        },
    },
}
export const eventSheet = {
    'wedding': sheet5,
    'christening': sheet4,
    'civil_wedding': sheet3,
    'party': sheet2,
    'conference': sheet1,
    'festival_salon': sheet1,
    'festival': sheet6,
    'private_events': sheet2,
    'corporate': sheet1,
    'playgrounds': sheet1,
    'deliveries_to_individuals': sheet1,
}

//festival - de adaugat - din contul celalalt